import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import style from './PaymentResult.module.scss';

const PaymentFailed = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const delayRedirect = setTimeout(() => {
			navigate('/');
		}, 5000);

		return () => {
			clearTimeout(delayRedirect);
		};
	}, [navigate]);
	return (
		<main className={style.failed}>
			<div className={style['failed__container']} role='alert' aria-live='assertive'>
				<div className={style['failed__icon']} aria-hidden='true'>
					<svg viewBox='0 0 24 24'>
						<path d='m8 8 8 8M16 8l-8 8' />
					</svg>
				</div>
				<div className={style['failed__content']}>
					<h1 className={style['failed__title']}>Платёж не выполнен</h1>
					<p className={style['failed__message']}>
						К сожалению, не удалось обработать ваш платёж. Пожалуйста, убедитесь в корректности введённых данных или
						обратитесь в ваш банк для уточнения деталей.
					</p>
					<span className={style['failed__hint']}>Через несколько секунд вы вернётесь на главную страницу.</span>
					<div className={style['failed__actions']}>
						<a href='/service/pay' className={style['failed__button']}>
							Повторить оплату
						</a>
						<a href='mailto:abonent@teorematelecom.ru' className={style['failed__link']}>
							Связаться с поддержкой
						</a>
					</div>
				</div>
			</div>
		</main>
	);
};

export default PaymentFailed;
